module.exports = __webpack_public_path__ + "img/1497935215.93f6a604.jpg";